import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePerformanceMonitoring from '../../hooks/usePerformanceMonitoring';
import analyticsService from '../../services/analyticsService';

const AnalyticsWrapper = ({ children, onLocationChange }) => {
    const location = useLocation();

    // Initialize performance monitoring (now has access to Router context)
    usePerformanceMonitoring();

    // Initialize analytics tracking
    useEffect(() => {
        try {
            // Check if analytics service is available and consent is given
            if (analyticsService && typeof analyticsService.initialize === 'function') {
                // Analytics will be initialized when consent is given via CookieConsent
                console.log('Analytics wrapper initialized for:', location.pathname);
            }
        } catch (error) {
            console.warn('Analytics wrapper error:', error);
        }
    }, [location.pathname]);

    // Call onLocationChange when location changes
    useEffect(() => {
        if (onLocationChange && typeof onLocationChange === 'function') {
            onLocationChange();
        }
    }, [location.pathname, onLocationChange]);

    return <>{children}</>;
};

export default AnalyticsWrapper;
